export default class Toast {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.delayDelete = 4000

        this.init()
    }

    init() {

    }

    reInit() {
    }

    show(message, type = 'success') {
        const container = this.$component.querySelector(`.js-basket-page-toast`)

        const toast = document.createElement('div')
        toast.classList.add('b-basket-page__toast', `b-basket-page__toast--${type}`)
        toast.innerText = message

        container.appendChild(toast)

        setTimeout(() => {
            toast.remove()
        }, this.delayDelete)

        toast.addEventListener('click', () => {
            toast.remove()
        })
    }
}
